import React, {useEffect,useContext} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction} from "mobx";
import PropTypes from "prop-types";
import { useDropzone } from "react-dropzone";
import {ComponentContext} from "../../../contexts";
import ContextButton from "../../Helpers/ContextButton";
import LinksUploader from "../MultiFile/LinksUploader";
import DataExporter from "../../Helpers/DataExporter";
import SingleBig from "./SingleBig";

function SingleFile(props) {
  const store = useLocalObservable(() => ({
    drag_over:false,
    show_links_uploader:false,
    mouse_over:false,
    show_big:false,
  }));
  const compStore=useContext(ComponentContext);

  useEffect(() => {
    // mount

    return () => {
      // unmount
    }
  }, []);

  const {getRootProps, getInputProps, isDragActive, open} = useDropzone({
    ...compStore.options.uploadOptions,
    onDrop:(files)=>{
      if(files.length) {
        runInAction(()=>{
          compStore.data.uploading_file = files[0]
          store.drag_over=false;
        });
        compStore.startUpload();
      }
    },
    onDragLeave:()=>{
      runInAction(()=>{ store.drag_over=false; });
    },
    onDragEnter:()=>{
      runInAction(()=>{ store.drag_over=true; });
    },
    noClick:true,
    noKeyboard:true
  });

  const fileUploadBtn=()=> {
    return (
      <>
        <span className="buttonsCombo">
          <span className="btn9" onClick={(e)=>{ e.preventDefault(); e.stopPropagation(); open(); }}><span><span className="mdi mdi-upload"></span> Загрузить</span></span>
          <ContextButton items={[
            {title:"Загрузить по ссылке", onClick:()=>{ store.show_links_uploader=true; }},
            {title:"Удалить", onClick:()=>{ compStore.data.delete=true; compStore.setMarkFileWas(); }},
          ]}>{(ret)=>{
            return (
              <span  className="btn9 iconOnly pr">
                <span {...ret.buttonProps}><span className="mdi mdi-dots-vertical"></span></span>
                {ret.Context}
              </span>
            )
          }}
          </ContextButton>
        </span>
        {store.show_links_uploader?(
          <div className="pa pa-tl bg-w1 padd5 shadow z4">
            <LinksUploader replace={true} single={true} onClose={()=>{ runInAction(()=>{ store.show_links_uploader=false; }); }} />
          </div>
        ):null}
      </>
    )
  };

  const nothingUploaded=()=>{
    return (
      <div className="up12 splice h100">
        <div className="cell s-12 s-middle">
          <div className="tac fs14">Перетащите сюда файл</div>
          <div className="ptop20 tac pr">
            {fileUploadBtn()}
          </div>
        </div>
      </div>
    );
  };
  const somethingUploaded=()=>{
    let lastFileWas=false;
    const lastPhoto=compStore.data;
    const lastFile=getFile();
    let last=(
      <div style={{width:100, height:60}} className="bg-w4 pr z4 smallShadow">
        {lastPhoto.fail?(
          <div className="b1 padd5 tac fs12 lh12">
            <div className="b5 mdi mdi-image-remove fs16 "></div>
            Файл не<br/>
            загрузился
          </div>
        ):null}
      </div>
    );
    const lastPhotoSrc=lastPhoto.tmp_file && lastPhoto.tmp_file.preview?lastPhoto.tmp_file.preview:(lastPhoto.preview || false);
    if(lastPhotoSrc) {
      last=(
        <img draggable={false} onLoad={function(e){ e.target.attributes.style.value=""; }} style={{width:100, height:60, objectFit:"cover"}} src={lastPhotoSrc} className="db pr z4 bg-w4 smallShadow" />
      )
    } else {
      if(!lastPhoto.fail && !lastPhoto.uploading_file && !lastPhoto.uploading_url) {
        lastFileWas=true;
        last = (
          <div className="pr z4 b1 fs12 lh14 tac ptop20 ofh ttu bold center  pr " style={{backgroundColor: lastFile.color, height:60, width: 45}}>
            <div className="pa pa-tr bg-w2" style={{borderColor:`#E5E5E5 #E5E5E5 #ffffff #ffffff`, borderWidth:10, borderStyle:"solid"}}></div>
            <div className="pa pa-bl fs12 bold w1 pleft5 pbottom2">{lastFile.ext}</div>
          </div>
        );
      }
    }

    return (
      <div className="tac h100 up12 splice pointer">
        <div className="cell s-12 tac s-middle">
          <div className="dib pr">
            {last}
          </div>
          <div className={` pa pa-bl w100 tac pbottom20 z4 ${(store.mouse_over || store.show_links_uploader) && !compStore.data.delete?"db":"dn"}`}>
            {fileUploadBtn()}
          </div>
        </div>
      </div>
    )
  };
  const openBigMode=()=> {
    if(getFile().public_url && !compStore.data.delete) {
      runInAction(() => {
        store.show_big = true;
      });
    }
  };

  const getFile=()=>{
    return compStore.data.tmp_file || compStore.data;
  }



  return (
    <div>
      <div
        className={`${getFile().public_url ? "bg-w3" : `dashed1 bo-w3`} rad3 bg-w1 gallerySmallMode padd10 pr`} {...getRootProps()}
        onMouseLeave={()=>{
          runInAction(()=>{ store.mouse_over=false; });
        }}
        onMouseEnter={()=>{
          runInAction(()=>{ store.mouse_over=true; });
        }}
        onClick={() => {
          openBigMode();
        }}>
        <input {...getInputProps()}/>
        {!getFile().public_url ? nothingUploaded() : somethingUploaded()}
        {store.drag_over ? (
          <div className="pa pa-tl w100 h100 bg-pc5 z4 dashed1 bo-pc1 rad3">
            <div className="up12 splice h100">
              <div className="cell s-12 tac s-middle tac fs14">
                Бросайте файл сюда
              </div>
            </div>
          </div>
        ) : null}
        {compStore.cur_progress.active ? (
          <div className="pa pa-tl w100 h100 bg-w1 z4 dashed1 bo-w3 rad3">
            <div className="up12 splice h100 s-center">
              <div className="cell s-10 tac s-middle tac">
                <div className="ptop2 rad4 ofh bg-w3 pr">
                  <div className="pa pa-tl h100 bg-pc1" style={{width: `${compStore.cur_progress.percent}%`}}></div>
                </div>
              </div>
            </div>
          </div>
        ) : null}
        {compStore.data.delete?(
          <div className="pa pa-tl w100 h100 bg-w1-op20 up12 splice z4">
            <div className="cell s-12 tac s-middle">
              <span className="const1">Фото будет удалено при сохранении</span>
              <div className="ptop20">
                <span onClick={(e)=>{
                  e.stopPropagation();
                  e.preventDefault();
                  runInAction(()=>{
                    delete compStore.data.delete;
                  });
                }} className="btn9 tac pr z4"><span><span className="mdi mdi-delete-restore "></span> Отменить удаление</span></span>
              </div>
            </div>
          </div>
        ):null}
      </div>
      <DataExporter />
      {store.show_big?<SingleBig onClose={()=>{ runInAction(()=>{ store.show_big=false; }); }} />:null}
    </div>
  )
};

SingleFile.defaultProps = {};

SingleFile.propTypes = {}

export default observer(SingleFile);
